export default "__VITE_ASSET__DR9X2BPf__"